const getErrorMessageByCode = (code: string): string => {
  switch (code) {
    case 'AU550':
      return 'Your frame target cannot be met. Please revise your chosen targets.';
    case 'AU554':
      return 'There are no frames available for the targeting criteria you have chosen. Please revise your chosen targets.';
    case 'AU500':
      return 'We cannot process your request at this moment. Please try again.';
    default:
      return '';
  }
};

export const apiErrorHandler = (response: {
  data?: { errors?: { code: string; message: string }[]; message?: string };
  status?: number;
}): React.ReactElement[] => {
  const errorMsgs = [];

  if (response?.data && response.data.errors && response.data.errors.length) {
    for (let i = 0; i < response.data.errors.length; i++) {
      const errorMessage = getErrorMessageByCode(response.data.errors[i].code);
      errorMsgs.push(<p key={i}>{errorMessage || response.data.errors[i].message}</p>);
    }
    return errorMsgs;
  }

  if (response?.status === 500 && response?.data?.message?.includes('AWS DYNAMODB : Could not save the entity')) {
    errorMsgs.push(
      <p>The file you uploaded is too large. Please upload a smaller file or split your file into smaller parts.</p>,
    );
    return errorMsgs;
  }

  if (response?.status === 500 || response?.status === 503) {
    errorMsgs.push(<p>We cannot process your request at this moment. Please try again.</p>);
    return errorMsgs;
  }

  // no availability error
  if (response?.data?.message) {
    errorMsgs.push(<p key={response.data.message}>{response.data.message}</p>);
  }

  return errorMsgs;
};

export const errorHandler = (error: { message: string }): React.ReactElement[] => {
  const errorMsgs = [];
  if (error?.message) {
    errorMsgs.push(<p>{error.message}</p>);
  }

  return errorMsgs;
};
